(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/draw-widgets/assets/javascripts/widget-container.js') >= 0) return;  svs.modules.push('/components/pool-betting/draw-widgets/assets/javascripts/widget-container.js');
"use strict";

const _svs$components$poolB = svs.components.poolBetting.drawWidgets,
  WidgetPublicContainer = _svs$components$poolB.WidgetPublicContainer,
  WidgetWagerContainer = _svs$components$poolB.WidgetWagerContainer;
const WidgetContainer = _ref => {
  let wagerId = _ref.wagerId,
    drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    className = _ref.className;
  if (wagerId) {
    return React.createElement(WidgetWagerContainer, {
      className: className,
      wagerId: wagerId
    });
  }
  if (drawNumber && productId) {
    return React.createElement(WidgetPublicContainer, {
      className: className,
      drawNumber: drawNumber,
      productId: productId
    });
  }
  return null;
};
setGlobal('svs.components.poolBetting.drawWidgets.WidgetContainer', WidgetContainer);

 })(window);